import React from 'react';
import { TextField } from '@mui/material';
import { useAppDispatch, useAppSelector } from '../../../../../../app/hooks';
import { updateTicketResolution } from '../../../../state';

/**
 * ResolutionDescriptionEdit - Field editor for ticket resolution description
 * Used to document the solution, outcome, or actions taken to resolve the ticket
 */
const ResolutionDescriptionEdit: React.FC = () => {
  const dispatch = useAppDispatch();
  const { currentTicket } = useAppSelector(state => state.ticket);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    dispatch(updateTicketResolution({
      description: event.target.value
    }));
  };

  return (
    <TextField
      label="Resolution Description"
      size="small"
      multiline
      rows={6}
      fullWidth
      value={currentTicket?.resolution?.description || ''}
      onChange={handleChange}
      placeholder="Describe how this ticket was resolved or the outcome..."
      helperText="Document the solution, outcome, or actions taken to resolve this ticket"
      InputProps={{
        sx: {
          alignItems: 'flex-start',
          '& .MuiInputBase-input': {
            paddingTop: '8px',
          }
        }
      }}
    />
  );
};

export default ResolutionDescriptionEdit;
